/**
 * Página de "En Construcción"
 * Se muestra para rutas que aún no están implementadas
 */

import styles from './UnderConstructionPage.module.css';

export function UnderConstructionPage() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.icon}>🚧</div>
        <h1 className={styles.title}>En Construcción</h1>
        <p className={styles.message}>
          Esta sección está en desarrollo y estará disponible pronto.
        </p>
      </div>
    </div>
  );
}

